export const ALL_OPTION = {
  id: 0,
  name: 'All',
};

export const DATE_FORMAT_LONG = 'MM/dd/yyyy hh:mm:ss a';
export const DATE_FORMAT_DATE = 'MM/dd/yyyy';

export const NO_DATA_VALUE = 'None';
